module.exports = __webpack_public_path__ + "static/img/image043.2a4eecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image043.png
// module id = WDA1
// module chunks = 1